<!-- Page Wrapper -->

<div id="wrapper">

    <app-sidebar> </app-sidebar>

    <!-- Content Wrapper -->
    <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">


            <app-topbar></app-topbar>

            <!-- Sidebar Toggle (Topbar) -->
                <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
                    <i class="fa fa-bars"></i>
                </button>

                

            <!-- Begin Page Content -->
            <div class="container-fluid">

                <!-- Page Heading -->
                <div class="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 class="h3 mb-0 text-gray-800">Tracking</h1>
                    
                        
                </div>
                <!-- picture_as_pdf -->
                

                <mat-form-field appearance="outline" style="width: 30%;">
                    <mat-label>Search</mat-label>
                    <input matInput (keyup)="ApplyFilter($event)" placeholder="Ex. 217070" #input>
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>

                <div class="row">
                    
                    <label>Filtering</label>
                    <mat-form-field style="width: 5%;" appearance="outline">
                        <input matInput placeholder="no" [(ngModel)]="filterEntity.id">
                    </mat-form-field>
                    <mat-form-field style="width: 10%;" appearance="outline">
                        <input matInput placeholder="First name" [(ngModel)]="filterEntity.firstname">
                    </mat-form-field>
                    <mat-form-field style="width: 10%;" appearance="outline">
                        <input matInput placeholder="Last name" [(ngModel)]="filterEntity.lastname">
                    </mat-form-field>
                    <mat-form-field style="width: 10%;" appearance="outline">
                        <input matInput placeholder="Student number" [(ngModel)]="filterEntity.studNum">
                    </mat-form-field>
                    <mat-form-field style="width: 10%;" appearance="outline">
                        <input matInput placeholder="Activity" [(ngModel)]="filterEntity.activity">
                    </mat-form-field>
                    <mat-form-field style="width: 10%;" appearance="outline">
                        <input type="datetime-local" matInput placeholder="Date and Time" [(ngModel)]="filterEntity.datetime">
                    </mat-form-field>
                    <mat-form-field style="width: 13%; overflow: hidden" appearance="outline">
                        <input [hidden]="true" matInput style="display: none;">
                        <mat-checkbox color="warn" (click)="groupEvent()" [(ngModel)]="groupValue">Group Tracks</mat-checkbox>
                    </mat-form-field>

                    <!--  -->
                </div>


                <div>
                    <table mat-table matTableFilter [exampleEntity]="filterEntity" [filterType]="filterType" [dataSource]="dataSource" matSort>

                        <!-- Position Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> No.</th>
                            <td mat-cell *matCellDef="let element"> {{element.id}}</td>
                        </ng-container>


                        <!--Firstname Name Column -->
                        <ng-container matColumnDef="firstname">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.firstname}} </td>
                        </ng-container>

                        <!-- Last name Column -->
                        <ng-container matColumnDef="lastname">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.lastname}} </td>
                        </ng-container>

                        <!-- Student number Column -->
                        <ng-container matColumnDef="studNum">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Student Number </th>
                            <td mat-cell *matCellDef="let element"> {{element.studNum}} </td>
                        </ng-container>

                        <!-- Student number Column -->
                        <ng-container matColumnDef="activity">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Activity </th>
                            <td mat-cell *matCellDef="let element"> {{element.activity}} </td>
                        </ng-container>

                        <!-- Student number Column -->
                        <ng-container matColumnDef="datetime">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Time And Date </th>
                            <td mat-cell *matCellDef="let element"> {{element.datetime}} </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">No data matching the filter </td>
                        </tr>
                    </table>

                    <mat-paginator [pageSizeOptions]="[10, 15, 20, 25]" [length]="100" [pageSize]="10" style="margin-bottom: 5%;"></mat-paginator>
                </div>

            </div>
        </div>
    </div>
</div>